import { render, staticRenderFns } from "./NavbarAfterLogin-v3.vue?vue&type=template&id=5b746d16&scoped=true&lang=pug"
import script from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
export * from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
import style0 from "./NavbarAfterLogin-v3.vue?vue&type=style&index=0&id=5b746d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b746d16",
  null
  
)

export default component.exports